/**
 * CRC32 (IEEE, полином 0xEDB88320) — контрольная сумма записей ZIP (задача 41).
 *
 * Без неё архив нечитаем: каждый файл в ZIP подписан CRC32, и распаковщик (проводник
 * Windows, 7-Zip) обязан сверить содержимое с этой подписью. Таблица считается один раз
 * на процесс — на 3000 сканов важна каждая операция для каждого байта.
 */

/** Таблица CRC32: 256 значений, собирается лениво при первом вызове. */
let table: Uint32Array | undefined;

/** Строит таблицу CRC32 (старший байт — индекс, восемь сдвигов — полином). */
function crcTable(): Uint32Array {
  if (table) return table;
  const values = new Uint32Array(256);
  for (let index = 0; index < 256; index += 1) {
    let value = index;
    for (let bit = 0; bit < 8; bit += 1) {
      value = value & 1 ? 0xedb88320 ^ (value >>> 1) : value >>> 1;
    }
    values[index] = value >>> 0;
  }
  table = values;
  return values;
}

/** Контрольная сумма CRC32 от байтов — 32-битное беззнаковое число. */
export function crc32(bytes: Uint8Array): number {
  const values = crcTable();
  let crc = 0xffffffff;
  for (const byte of bytes) {
    crc = values[(crc ^ byte) & 0xff] ^ (crc >>> 8);
  }
  return (crc ^ 0xffffffff) >>> 0;
}